export default __webpack_public_path__ + "static/media/ticon4.73000435.jpg";